import { createStyles, getStylesRef } from "@mantine/core"

const AI_SEARCH_POPDOWN_HEIGHT = "24rem"

export const useStyles = createStyles((theme, { isLearnMoreExpanded = false }: { isLearnMoreExpanded: boolean }) => ({
    aiPopdown: {
        backgroundColor: "white",
        border: `1px solid ${theme.colors.gray[2]}`,
        borderRadius: "0.25rem",
        boxShadow: theme.shadows.xl,
        padding: "0",
        color: theme.colors.gray[7],
        minHeight: AI_SEARCH_POPDOWN_HEIGHT,
        width: "55rem",
        height: "42rem",
        overflow: "hidden",
    },
    aiContainer: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
    },
    aiPaddedText: {
        padding: "1.5rem 2rem",
        fontSize: "0.875rem",
        height: "100%",
        "& .mantine-Text-root": {
            color: theme.colors.gray[9],
        },
    },
    aiExpandedText: {
        padding: "1.5rem 2rem",
    },
    aiTitle: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        fontSize: "1.25rem",
        fontWeight: 500,
    },
    aiLearnMoreButton: {
        paddingLeft: 0,
        margin: isLearnMoreExpanded ? "1rem 0 0 0" : "1rem 0",
    },
    aiSearchSegue: {
        color: theme.colors.gray[7],
        width: "100%",
    },
    aiExampleItem: {
        backgroundColor: theme.colors.gray[0],
        borderRadius: "1.25rem",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "0.5rem",
        height: "2.5rem",
        padding: "0.5rem 0.5rem 0.5rem 1rem",
        transition: "0.25s",
        "&:hover": {
            boxShadow: `0px 3px 5px ${theme.colors.gray[3]}`,
        },

        // referencing button with nested selector
        [`&:hover .${getStylesRef("aiExampleButton")}`]: {
            opacity: 1,
            transition: "0.25s",
        },
    },
    aiExampleBulletPoint: {
        padding: "0",
        // resizing the Icon to use as a tiny bullet point
        fontSize: "0.75rem",
    },
    aiExampleText: {
        fontSize: "14px",
        display: "flex",
        alignItems: "center",
        gap: "0.5rem",
    },
    aiExampleButton: {
        // assigning reference to selector
        ref: getStylesRef("aiExampleButton"),
        borderRadius: "1.25rem",
        backgroundColor: theme.colors.violet[5],
        color: "white",
        height: "1.5rem",
        padding: "0.3rem 0.5rem 0.25rem 0.5rem",
        fontSize: "0.75rem",
        opacity: 0,
    },
    aiFooter: {
        backgroundColor: theme.colors.violet[0],
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "0 0 0 1rem",
        fontSize: "0.75rem",
        minHeight: "3rem",
        "& > div": {
            display: "flex",
            alignItems: "center",
            gap: "0.75rem",
            width: "100%",
        },
        "& svg": {
            fontSize: "0.875rem",
        },
    },
    aiFooterDatasets: {
        fontWeight: 500,
    },
    aiStandardSearchButton: {
        ".mantine-Button-label": {
            fontSize: "0.75rem",
            fontWeight: 500,
        },
    },
    aiLoading: {
        height: "100%",
    },
    aiAlertStateButtons: {
        padding: theme.spacing.xs,
        fontSize: "0.875rem",
        lineHeight: "1.2",
    },
    aiAlertStateCancelButtons: {
        fontSize: "0.875rem",
    },
    aiAlertStateButtonContainer: {
        gap: "0.75rem",
        marginTop: "1rem",
    },
    aiAlertStateContainer: {
        padding: "3rem 4rem",
        maxWidth: "47rem",
        width: "100%",
        margin: "0 auto",
        gap: "3rem",
        alignItems: "self-start",
    },
    aiAlertStateTitle: {
        fontSize: "1.125rem",
        fontWeight: 500,
    },
    aiAlertObj: {
        fontSize: "0.875rem",
    },
}))
